import React, {useEffect} from 'react';

interface EventDispatcherProps {
    events: string[];
    children?: React.ReactNode;
}

const EventDispatcher = ({events, children = null}: EventDispatcherProps) => {
    useEffect(() => {
        events.forEach((event) => document.dispatchEvent(new Event(event)));
    }, []);
    return children;
};

export default EventDispatcher;
